import { z } from 'zod';

// Zod v4 compiles object parsers with `new Function` (JIT), which browsers report
// as an eval CSP violation on every page load. jitless mode uses the ordinary
// parse path instead — identical results, slightly slower parsing. The flag is
// read when a schema is *constructed*, and our schemas are built at module import
// time, so this module must be the first import in the entry file.
z.config({ jitless: true });
